<!-- begin:: Page -->
<template>
  <div class="m-grid m-grid--hor m-grid--root m-page" style="height: 100%">
    <div
      class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin"
      id="m_login">
      <div
        class=" b m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1 m-login__content m-grid-item--center"
        :style="'background: url('+cdn_url+'/img/bg/bg-login.jpg) no-repeat center center / COVER'">

        <div class="m-grid__item">
          <img alt="" :src="cdn_url+'/img/logos/white.png'" width="250px">
          <p class="m-login__msg">{{ $t('app.name') }}</p>

          <form class="m-login__form m-form" @submit.prevent="doLogin">
            <div class="form-group m-form__group mt-3">

              <input class="form-control m-input" type="text" :placeholder="$t('Login.login')" name="login"
                     v-model="login" autocomplete="off" required>
            </div>
            <div class="form-group m-form__group mt-0 pt-0">
              <input class="form-control m-input m-login__form-input--last" type="password" v-model="password"
                     :placeholder="$t('Login.password')" autocomplete="off" name="password" required>
            </div>

            <div class="m-login__form-action">
              <button type="submit" id="m_login_signin_submit"
                      class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air">{{$t('Login.signinbtn') }}
              </button>
            </div>
          </form>

        </div>

        <div v-if="!cookieAccepted"
             role="alert"
             class="m-alert m-alert--icon m-alert--air m-alert--square alert alert-dismissible fade show cookie-consent">
          <div class="m-alert__icon"><i class="flaticon-exclamation-1"></i>
            <span></span>
          </div>
          <div class="m-alert__text text-center">
            <span class="cookie-consent--span">
              <strong>{{$t('common.COOKIES')}}:</strong> {{$t('common.CookiesConsent')}}.
            </span>
            <button type="button"
                    @click="acceptCookieConsent(true)"
                    data-dismiss="alert"
                    aria-label="Close"
                    class="d-inline btn btn-sm btn-primary btn-sm-block cookie-consent--button">{{$t('common.ok')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- end:: Page -->
<script>

  import functions from "@/plugins/functions"
  import authapi from '@/interceptors/authapi'
  import {adminauthapiwithoutrefresh} from '@/interceptors/adminauthapi'
  import Cookie from 'js-cookie'

  export default {
    name: 'Login',
    data() {
      return {
        cookieAccepted: false,
        cdn_url: process.env.CDN_URL,
        login: '',
        password: ''
      }
    },
    methods: {
      async loginUser(){

        let res = await authapi.post('/client/auth', { login: this.login, password: this.password })

        if (res.status != 200) {
          swal({
            title: "",
            text: this.$t('Login.loginFailed'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          });
          return
        }

        Cookie.set('access_token', res.data.accessToken, { expires: 3, sameSite: 'Strict' });
        Cookie.set('refresh_token', res.data.refreshToken, { expires: 3, sameSite: 'Strict' });

        //you can now redirect user
        await this.$router.replace(this.$route.query.redirect?this.$route.query.redirect:'/dashboard')

        let user = functions.getUserFromToken(res.data.accessToken)
        toastr.success(this.$t('Dashboard.welcomeMsg', {userName: user.TradeName || user.CompanyName}));
      },
      async loginAdmin(){
        let res = await adminauthapiwithoutrefresh.post('/internal/auth', { email: this.login, password: this.password })

        if (res.status != 200) {
          swal({
            title: "",
            text: this.$t('Login.loginFailed'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          });
          return
        }

        Cookie.set('admin_access_token', res.data.accessToken, { expires: 3, sameSite: 'Strict' });
        Cookie.set('admin_refresh_token', res.data.refreshToken, { expires: 3, sameSite: 'Strict' });

        await this.$router.replace('/admin')

        let user = functions.getUserFromToken(res.data.accessToken)

        toastr.success(this.$t('Dashboard.welcomeMsg', {userName: user.Name}));
        return
      },
      async doLogin() {

        if (functions.checkIfEmail(this.login)){
          await this.loginAdmin()
          return
        }

        await this.loginUser()
      },

      acceptCookieConsent(){
        Cookie.set('cookie_consent', 'true', { expires: 356, sameSite: 'Strict' });
        this.cookieAccepted = true
      },
    },
    created() {
      $('.loading').fadeOut();

      if (Cookie.get('access_token')) {
        let toUrl = this.$route.query.redirect?this.$route.query.redirect:'/dashboard'
        this.$router.replace(toUrl).then((res) => {}).catch((res) => {})
      }
    },
    mounted() {
      if (Cookie.get('cookie_consent')){
        this.cookieAccepted = true
        return
      }

      this.$utils.fadeOutLoading()
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/users/Login.vue